import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
  business_name: "Ascendia Detail",
  tagline: "Premium Property Detailing",
  phone: "058-779-0553",
  phone_intl: "972587790553",
  email: "contact.ascendiahq@gmail.com",
  instagram: "https://www.instagram.com/ascendiadetail",
  instagram_handle: "@ascendiadetail",
  whatsapp_message: "Hi Ascendia Detail, I'm interested in receiving a quote for my property.",
  service_area: "Throughout Israel",
  logo: "https://static.wixstatic.com/media/e87b53_bdabe42f72ef4dc1b42f9d23dfa9c233~mv2.png",
};

const SiteContext = createContext(DEFAULTS);
export const useSite = () => useContext(SiteContext);

export function whatsappLink(site) {
  const num = site?.phone_intl || "972587790553";
  const msg = encodeURIComponent(site?.whatsapp_message || "");
  return `https://wa.me/${num}?text=${msg}`;
}

export function SiteProvider({ children }) {
  const [site, setSite] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/site-content").then(({ data }) => data && setSite({ ...DEFAULTS, ...data })).catch(() => {});
  }, []);
  return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>;
}
